import { useSecureGraphqlQuery } from '@psyomics/ui-common';

import {
  GetAppInfoDetailsDocument,
  GetAppInfoDetailsQuery,
  GetAppInfoDetailsQueryVariables,
  Maybe,
  AppInfo,
} from '../generated/app-info';

export const useGetAppInfoDetails = (): [Maybe<AppInfo> | undefined, boolean] => {
  const [{ data, fetching }] = useSecureGraphqlQuery<GetAppInfoDetailsQuery, GetAppInfoDetailsQueryVariables>({
    query: GetAppInfoDetailsDocument,
    variables: {},
  });
  const result = data?.getAppInfo;

  return [result, fetching];
};
